<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">期间汇率管理</span>
			<Button color="green" size="small" @click="openCarry">期末汇兑损益结转</Button>
		</div>
		<div class="rate-body">
			<div class="add-box">
				<span class="add-label">币别：</span>
				<select v-model="addForm.currencyId">
					<option v-for="c in currencies" :value="c.id" :key="c.id">{{c.code}} - {{c.name}}</option>
				</select>
				<span class="add-label">年：</span>
				<input type="number" v-model.number="addForm.year" class="year-input">
				<span class="add-label">月：</span>
				<select v-model.number="addForm.month" class="month-input">
					<option v-for="m in 12" :value="m" :key="m">{{m}}月</option>
				</select>
				<span class="add-label">汇率：</span>
				<input type="number" step="0.000001" v-model.number="addForm.rate" class="rate-input" placeholder="1外币=?本位币">
				<Button color="green" size="small" @click="add">保存汇率</Button>
				<span class="tip">同一币别同一期间只保留一条汇率，重复保存将提示</span>
			</div>

			<table class="h-table" style="width:100%;margin-top:10px;">
				<tr>
					<th style="width:180px;">币别</th>
					<th style="width:100px;">年度</th>
					<th style="width:100px;">月份</th>
					<th>记账汇率</th>
					<th style="width:80px;">操作</th>
				</tr>
				<tr v-for="r in rates" :key="r.id">
					<td>{{r.currencyCode}} - {{r.currencyName}}</td>
					<td>{{r.year}}</td>
					<td>{{r.month}}月</td>
					<td>{{r.rate}}</td>
					<td><span class="text-hover red-color" @click="del(r)">删除</span></td>
				</tr>
				<tr v-if="!rates.length">
					<td colspan="5" class="text-center padding dark4-color">暂无汇率记录</td>
				</tr>
			</table>
		</div>

		<Modal v-model="carryModal" :width="520">
			<div slot="header">期末汇兑损益结转</div>
			<div class="carry-form">
				<div class="form-row">
					<div class="label">结转年度</div>
					<div class="control"><input type="number" v-model.number="carryForm.year"></div>
				</div>
				<div class="form-row">
					<div class="label">结转月份</div>
					<div class="control">
						<select v-model.number="carryForm.month">
							<option v-for="m in 12" :value="m" :key="m">{{m}}月</option>
						</select>
					</div>
				</div>
				<div class="form-row">
					<div class="label">汇兑损益科目</div>
					<div class="control">
						<select v-model="carryForm.subjectId">
							<option v-for="s in subjects" :value="s.id" :key="s.id">{{s.code}} - {{s.name}}</option>
						</select>
					</div>
				</div>
				<div class="tip-block">
					系统按所选期间汇率，逐币别计算「原币净额×汇率 − 已记本位币净额」差额，生成汇兑损益结转凭证。同一期间重复执行不会重复生成。
				</div>
			</div>
			<div slot="footer">
				<Button color="green" :loading="carryLoading" @click="doCarry">执行结转</Button>
				<Button color="primary" @click="carryModal=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	export default {
		name: 'ExchangeRate',
		data() {
			let now = new Date();
			return {
				currencies: [],
				rates: [],
				subjects: [],
				addForm: {
					currencyId: null,
					year: now.getFullYear(),
					month: now.getMonth() + 1,
					rate: null
				},
				carryModal: false,
				carryLoading: false,
				carryForm: {
					year: now.getFullYear(),
					month: now.getMonth() + 1,
					subjectId: null
				}
			};
		},
		methods: {
			loadData() {
				this.$api.setting.currency.list().then(({data}) => {
					//本位币无需维护期间汇率
					this.currencies = (data || []).filter(c => c.id && !c.localCurrency);
				});
				this.$api.setting.exchangeRate.list().then(({data}) => {
					this.rates = data || [];
				});
			},
			add() {
				if (!this.addForm.currencyId) {
					this.$Message('请选择币别');
					return;
				}
				if (!this.addForm.year || !this.addForm.month) {
					this.$Message('请填写年度和月份');
					return;
				}
				if (!this.addForm.rate) {
					this.$Message('请填写汇率');
					return;
				}
				this.$api.setting.exchangeRate.save(this.addForm).then(() => {
					this.$Message('保存成功');
					this.addForm.rate = null;
					this.loadData();
				});
			},
			del(r) {
				this.$Confirm(`确认删除 ${r.year}年${r.month}月 ${r.currencyCode} 的汇率?`).then(() => {
					this.$api.setting.exchangeRate.delete(r.id).then(() => {
						this.$Message('删除成功');
						this.loadData();
					});
				});
			},
			openCarry() {
				this.carryModal = true;
				if (!this.subjects.length) {
					this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
						this.subjects = this.flatten(data || []);
					});
				}
			},
			flatten(list) {
				let result = [];
				(list || []).forEach(item => {
					result.push(item);
					if (item.children && item.children.length) {
						result = result.concat(this.flatten(item.children));
					}
				});
				return result;
			},
			doCarry() {
				if (!this.carryForm.year || !this.carryForm.month) {
					this.$Message('请选择结转期间');
					return;
				}
				if (!this.carryForm.subjectId) {
					this.$Message('请选择汇兑损益科目');
					return;
				}
				this.carryLoading = true;
				this.$api.setting.exchangeRate.carry(this.carryForm).then(({data}) => {
					this.$Message(`结转完成，已生成凭证，凭证号：${data.code}`);
					this.carryModal = false;
				}).finally(() => {
					this.carryLoading = false;
				});
			}
		},
		mounted() {
			this.loadData();
		}
	};
</script>

<style lang='less' scoped>
	.rate-body {
		padding: 15px 20px;
	}

	.add-box {
		border: 1px solid @border-color;
		background: @tag-background-color;
		padding: 10px 15px;

		.add-label {
			margin-left: 8px;
		}

		.year-input {
			width: 90px;
		}

		.month-input {
			width: 70px;
		}

		.rate-input {
			width: 150px;
		}

		.tip {
			color: @dark4-color;
			font-size: 12px;
			margin-left: 12px;
		}
	}

	.carry-form {
		.form-row {
			display: flex;
			padding: 8px 0;

			.label {
				width: 100px;
			}

			.control {
				flex: 1;

				input, select {
					width: 240px;
				}
			}
		}

		.tip-block {
			margin-top: 10px;
			padding: 8px 12px;
			background: @tag-background-color;
			color: @dark4-color;
			font-size: 12px;
			border-radius: 4px;
		}
	}
</style>
